import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { BroadcastViewContent } from 'pages/broadcasts/ui/BroadcastView/ui/BroadcastViewContent'
import { type BroadcastViewStore } from 'pages/broadcasts/ui/BroadcastView'
import { BroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'

type IBroadcastViewProps = {
  store: BroadcastViewStore
}

export const BroadcastView = observer(({ store }: IBroadcastViewProps) => {
  return useMemo(
    () => (
      <BroadcastViewContext.Provider value={store}>
        <BroadcastViewContent />
      </BroadcastViewContext.Provider>
    ),
    []
  )
})
